/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'project-content.project-content-about.the-measure-placeholder':
    'Descreva como é o sucesso e o que você espera alcançar.',
  'project-content.project-content-about.the-measure-title': 'Como a gente pode verificar o sucesso',
  'project-content.project-content-about.the-what-placeholder': 'Descreva esse projeto e o trabalho que ele envolve.',
  'project-content.project-content-about.the-what-title': 'O que a gente está fazendo',
  'project-content.project-content-about.the-why-placeholder':
    'Explique por que esse trabalho está acontecendo e os motivos que o estão impulsionando.',
  'project-content.project-content-about.the-why-title': 'Por que a gente está fazendo isso',
  'project-content.project-content-updates.add-update': 'Adicionar atualização',
  'project-content.project-content-updates.archived': 'Arquivado',
  'project-content.project-content-updates.at-risk': 'Em risco',
  'project-content.project-content-updates.cancelled': 'Cancelado',
  'project-content.project-content-updates.completed': 'Concluído 🎉',
  'project-content.project-content-updates.date-changed': 'Data alterada',
  'project-content.project-content-updates.edit-update': 'Editar',
  "project-content.project-content-updates.for-date'": 'para {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Última atualização',
  'project-content.project-content-updates.missed-update-message': 'Nenhuma atualização foi publicada',
  'project-content.project-content-updates.new-due-date': 'Nova data de entrega',
  'project-content.project-content-updates.new-state': 'Novo estado',
  'project-content.project-content-updates.no-updates-description': 'Ainda não há atualizações para esse projeto.',
  'project-content.project-content-updates.off-track': 'Fora dos trilhos',
  'project-content.project-content-updates.old-due-date': 'Data de entrega antiga',
  'project-content.project-content-updates.old-state': 'Estado antigo',
  'project-content.project-content-updates.on-track': 'Nos trilhos',
  'project-content.project-content-updates.paused': 'Pausado',
  'project-content.project-content-updates.pending': 'Pendente',
  'project-content.project-content-updates.previous-updates-title': 'Atualizações anteriores',
  'project-content.project-content-updates.share-update': 'Compartilhar',
  'project-content.project-content-updates.status-changed': 'Status alterado',
  'project-content.project-content-updates.write-update-button': 'Escreva uma atualização',
};
